import Nexfar from '../services/Nexfar';
import Masks from "../services/Masks";

export default {
    
    props: [],

    data: () => { return {
        
    }},
    mounted: function() {
        let self = this;
         
        window.onscroll = function() {
            self.scrollFunction();
        };

    },
    methods: {
        scrollFunction(){
            if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
                document.getElementById("btnGoTo").style.display = "block";
            } else {
                document.getElementById("btnGoTo").style.display = "none";
            }
        },
        goScrollTop(){
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth"
            });
        }
    }

}
